// extracted by mini-css-extract-plugin
module.exports = {"entitySelector":"DialogStyles_entitySelector__3jVMi"};